import PropTypes from "prop-types";
import { CircleIcon } from "@phosphor-icons/react";

/**
 * A horizontal dotted line with optional labels on each end.
 *
 * @param {object} props
 * @param {string} [props.startLabel] - Label displayed on the left side of the line.
 * @param {string} [props.endLabel] - Label displayed on the right side of the line.
 */
const DottedLine = ({ startLabel, endLabel }) => {
  return (
    <div
      className="flex items-start gap-3 w-full"
      role="separator"
      aria-label={
        startLabel && endLabel
          ? `${startLabel} a ${endLabel}`
          : startLabel || endLabel || undefined
      }
    >
      <div className="flex flex-col items-center gap-0.5 shrink-0">
        {startLabel && (
          <span className="whitespace-nowrap font-bold" aria-hidden="true">
            {startLabel}
          </span>
        )}
      </div>

      <div
        aria-hidden="true"
        className="flex items-center justify-center flex-1 mt-1 gap-[2px]"
      >
        <CircleIcon size={10} weight="fill" className="text-gray-400" />
        <div
          className="flex-1"
          style={{
            borderTop: "2px dotted",
            borderColor: "rgb(156, 163, 175)", // Tailwind's gray-400
          }}
        />
        <CircleIcon size={10} weight="fill" className="text-gray-400" />
      </div>

      <div className="flex flex-col items-center gap-0.5 shrink-0">
        {endLabel && (
          <span className="whitespace-nowrap font-bold" aria-hidden="true">
            {endLabel}
          </span>
        )}
      </div>
    </div>
  );
};

DottedLine.propTypes = {
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
};

export default DottedLine;
